import React from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Header from "../component/Header";
import CommonBanner from "../component/CommonBanner";
import Footer from "../component/Footer";
import { Col, Container, Row, Button } from "react-bootstrap";
import ExploreResultLocations from "../component/ExploreResultLocations";
import HomeRealEstateAgentForm from "../component/HomeRealEstateAgentForm";
import { resources } from "../data/resourcesData";
import LeftArrow from "../assets/images/left-arrow.svg";

const ArrowIcon = ({ direction = "right" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={direction === "left" ? { transform: "scaleX(-1)" } : undefined}
  >
    <path
      d="M3.33301 10H16.6663M16.6663 10L11.6663 5M16.6663 10L11.6663 15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

function ResourceDetails() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const currentIndex = Math.max(
    0,
    resources.findIndex((item) => item.slug === slug)
  );
  const resource = resources[currentIndex];
  const prevResource = currentIndex > 0 ? resources[currentIndex - 1] : null;
  const nextResource =
    currentIndex < resources.length - 1 ? resources[currentIndex + 1] : null;

  return (
    <>
      <div className="main resources-details-page">
        <Header />
        <CommonBanner title={resource.title} />
        <section className="resources-details-section common-padding">
          <Container>
            <Row>
              <Col lg={9} className="mx-auto">
                <div className="back-header">
                  <button
                    className="back-button detail-btn"
                    onClick={() => navigate('/resources')}
                  >
                    <img src={LeftArrow} alt="Back" />
                  </button>
                  <div className="header-content">
                    <p className="subtitle">Back to list</p>
                  </div>
                </div>
                <h2>{resource.title}</h2>
                <p className="intro">{resource.description}</p>

                {resource.steps.map((step) => (
                  <div className="detail-step" key={step.heading}>
                    <h3>{step.heading}</h3>
                    {step.intro && <p>{step.intro}</p>}
                    {step.subheading && <p className="step-subheading">{step.subheading}</p>}
                    {step.bullets && (
                      <ul>
                        {step.bullets.map((bullet) => (
                          <li key={bullet}>{bullet}</li>
                        ))}
                      </ul>
                    )}
                    {step.checklist && (
                      <ul className="checklist">
                        {step.checklist.map((item) => (
                          <li key={item}>{item}</li>
                        ))}
                      </ul>
                    )}
                    {step.intro2 && <p>{step.intro2}</p>}
                  </div>
                ))}
                {resource.finalThoughts.map((thought) => (
                  <div className="detail-step" key={thought.title}>
                    <h3>{thought.title}</h3>
                    <p>{thought.description}</p>
                    {thought.description2 && <p>{thought.description2}</p>}
                  </div>
                ))}

                <div className="resource-nav-actions">
                  {prevResource && (
                    <Button
                      as={Link}
                      to={`/resources/${prevResource.slug}`}
                      className="custom-bttn style-1 left"
                    >
                      <ArrowIcon direction="left" />
                      Previous Resource
                    </Button>
                  )}
                  {nextResource && (
                    <Button
                      as={Link}
                      to={`/resources/${nextResource.slug}`}
                      className="custom-bttn style-1 right ms-auto"
                    >
                      Next Resource
                      <ArrowIcon direction="right" />
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <HomeRealEstateAgentForm />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}

export default ResourceDetails;
